export const SET_AUTH_TOKENS = 'setAuthTokens';
export const INITIALIZE_FROM_COOKIES = 'initFromCookies';
export const CLEAR_TOKENS = 'clearTokens';
export const SET_REDIRECT = 'setRedirect';
